// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2863":"432a605ab52b7240","3185":"2b264e7bc6b75686","4025":"432a605ab52b7240"}[chunkId] + ".css";
};